import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "./styles.scss";

export interface CodeSelectOption {
  value: string;
  label: string;
}

interface Props {
  value: string;
  options: CodeSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const CodeSelectDropdown: React.FC<Props> = ({
  value,
  options,
  placeholder = "Select a code",
  disabled = false,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const selectedOption = options.find(option => option.value === value);
  const displayLabel = selectedOption?.label || placeholder;

  return (
    <Dropdown
      isOpen={open}
      toggle={() => {
        if (!disabled) {
          setOpen(prev => !prev);
        }
      }}
      disabled={disabled}
      className={styles.root}
    >
      <DropdownToggle
        caret
        className={styles.toggle}
        color="none"
        disabled={disabled}
      >
        {displayLabel}
      </DropdownToggle>
      <DropdownMenu className={styles.menu}>
        {options.map(option => (
          <div
            key={option.value}
            role="button"
            tabIndex={0}
            onClick={() => {
              onChange(option.value);
              setOpen(false);
            }}
            onKeyDown={event => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onChange(option.value);
                setOpen(false);
              }
            }}
            className={
              value === option.value ? styles.itemActive : styles.item
            }
          >
            {option.label}
          </div>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default withStyles(styles)(CodeSelectDropdown);
